const el = document.querySelector('.brand-carousel .bc-container');
const spaceBetweenMobile = parseInt(el.dataset.gapMobile);
const spaceBetweenDesktop = parseInt(el.dataset.gapDesktop);
var swiper = new Swiper('.brand-carousel .bc-swiper', {
    spaceBetween: spaceBetweenMobile,
    slidesPerView: 2.5,
    grabCursor: true,
    keyboard: {
        enabled: true,
    },
    breakpoints: {
        769: {
            spaceBetween: spaceBetweenDesktop,
            slidesPerView: 3,
        },
        1024: {
            spaceBetween: spaceBetweenDesktop,
            slidesPerView: 4,
        },
        1600: {
            spaceBetween: spaceBetweenDesktop,
            slidesPerView: 5,
        }
    },
    navigation: {
        nextEl: '.brand-carousel .bc-pagination .swiper-button-next',
        prevEl: '.brand-carousel .bc-pagination .swiper-button-prev',
    },
    pagination: {
        el: '.brand-carousel .bc-footer .swiper-pagination',
        clickable: true,
    },
});
